import React from 'react';

const PrivacyPage = () => (
  <div className="max-w-2xl mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
    <p className="mb-4">Your privacy is important to us. This policy explains what information we collect and how we use it.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
    <p className="mb-4">We collect information you provide directly, such as your email address and reminders you create. We may also collect usage data to improve the service.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Information</h2>
    <p className="mb-4">We use your information to provide and improve Strangeminder, communicate with you, and ensure the security of our service.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">3. Sharing of Information</h2>
    <p className="mb-4">We do not sell your personal information. We may share data with service providers as needed to operate Strangeminder.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
    <p className="mb-4">We take reasonable measures to protect your data, but no system is 100% secure.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">5. Changes to This Policy</h2>
    <p className="mb-4">We may update this Privacy Policy from time to time. Continued use of the service means you accept the new policy.</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">6. Contact</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at support@strangeminder.com.</p>
  </div>
);

export default PrivacyPage; 